<template>
	<div class="base_list_item" :class="{ border: !hideBorder, [type]: type, [size]: size }" @click="$emit('click')">
		<span class="base_list_item_dot" v-if="dot"></span>
		<div class="base_list_item__content">
			<van-checkbox class="checkbox" v-if="!hideChecked" v-model="modelValue"></van-checkbox>
			<p class="info">
				{{ userName || '--' }} · {{ gender || '--' }} {{ age || 0 }}岁
				<span v-if="!hideTag" class="tag" :class="tagClass">{{ tag || '--' }}</span>
			</p>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'BaseListItem',
		props: {
			value: {
				type: [Boolean, String, Number],
				default: ''
			},
			dot: {
				type: Boolean,
				default: false
			},
			userName: {
				type: String,
				default: ''
			},
			gender: {
				type: String,
				default: ''
			},
			age: {
				type: [String, Number],
				default: ''
			},
			tag: {
				type: String,
				default: ''
			},
			tagClass: {
				type: String,
				default: ''
			},
			type: {
				type: String,
				default: ''
			},
			hideChecked: {
				type: Boolean,
				default: false
			},
			hideBorder: {
				type: Boolean,
				default: false
			},
			hideTag: {
				type: Boolean,
				default: false
			},
			size: {
				type: String,
				default: ''
			}
		},
		computed: {
			modelValue: {
				get () {
					return this.value
				},
				set (val) {
					this.$emit('input', val)
				}
			}
		}
	};
</script>

<style scoped lang="less">
	.base_list_item {
		box-sizing: border-box;
		min-height: 130px;
		border-radius: 20px;
		padding: 40px;
		position: relative;
		&.border {
			border: 2px solid #DEE0E3;
		}
		.base_list_item_dot {
			position: absolute;
			right: -3px;
			top: -3px;
			width: 14px;
			height: 14px;
			border-radius: 50%;
			background-color: @danger;
		}
		.base_list_item__content {
			display: flex;
			align-items: center;
			.checkbox {
				flex: 0 0 42px;
				margin-right: 24px;
			}
			.info {
				flex: auto;
				font-family: PingFangSC-Medium;
				font-size: 36px;
				font-weight: 500;
				color: #1F2329;
				.tag {
					display: inline-block;
					vertical-align: middle;
					margin-left: 12px;
					height: 44px;
					padding: 0 12px;
					font-family: PingFangSC-Medium;
					font-size: 26px;
					color: #FFF;
					line-height: 46px;
					border-radius: 8px;
					background-color: #BBBFC4;
					&.primary { background-color: @primary; }
				}
			}
		}
		&.small {
			min-height: 114px;
			padding: 32px 40px;
			.info {
				.tag { vertical-align: bottom; }
			}
		}
		&.active, &.primary {
			&.border {
				border-color: @primary;
			}
			background-color: mix(#fff, @primary, 90%);
			.info {
				color: @primary;
				.tag {
					background-color: @primary;
				}
			}
		}
	}
</style>
